<script>
import deliveryUnitVue from "../modals/delivery-unit.vue";
export default {
  name: "DeliveryUnitAcessList",
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    userSelectedAccess: {
      type: Array,
      default: () => [],
    },
    isDeliveryUnitAccessListActive: {
      type: Boolean,
      default: false,
    },
    busy: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      selectedItems: [],
      search: "",
    };
  },
  methods: {
    processAccess() {
      this.$swal({
        title: "Are you sure?",
        text: "You are setting delivery unit access to this user",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#198754",
        confirmButtonText: "Yes, allow it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.list.forEach((campus) => {
            campus.deliveryUnits.forEach((deliveryUnit) => {
              if (deliveryUnit.isSelected) {
                this.selectedItems.push({
                  deliveryUnitId: deliveryUnit.id,
                  withDeliveryUnitAccess: deliveryUnit.withAccess,
                });
              }
            });
          });
          this.$emit("post", this.selectedItems);
        }
      });
    },
    hasMatchingString(item) {
      for (const du in item) {
        if (
          typeof item[du] === "string" &&
          item[du].toLowerCase().includes(this.search.toLowerCase())
        ) {
          return true;
        }
      }
      return false;
    },
    doSearch(event) {
      this.search = event.target.value;
    },
    clearSearch() {
      this.search = "";
      this.$refs.search.localValue = "";
      this.$refs.search.focus();
    },
  },
  computed: {
    filteredList() {
      /** filter delivery unit inside this.list */
      if (this.search == "") return this.list;

      let filteredArr = [];
      this.list.forEach((item) => {
        if (this.hasMatchingString(item)) {
          filteredArr.push(item);
        }
        if (item.deliveryUnits) {
          let matchingChildren = item.deliveryUnits.filter((child) =>
            this.hasMatchingString(child)
          );
          if (matchingChildren.length) {
            filteredArr.push({ ...item, deliveryUnits: matchingChildren });
          }
        }
      });
      return filteredArr;
    },
  },
};
</script>

<template>
  <div>
    <b-modal
      :visible="isDeliveryUnitAccessListActive"
      title="Delivery Unit Access List"
      size="lg"
      dialog-class="modal-dialog-centered"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      hide-backdrop
      @hidden="() => $emit('closeModal')"
    >
      <div class="d-flex justify-content-center align-items-center mb-2" v-if="busy">
        <div class="preloader-component me-2">
          <div class="status">
            <div class="spinner-chase w-20px h-20px">
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
            </div>
          </div>
        </div>
        <strong>Loading...</strong>
      </div>
      <div v-else>
        <div class="row">
          <div class="col-md-8">
            <div id="user" class="w-100">
              <div>
                <span>Name: </span>
                <span class="card-title text-warning">{{
                  user.applicationUser.completeName
                }}</span>
              </div>
              <div class="mb-2">
                <span>Delivery Unit: </span>
                <span class="card-title text-warning">{{
                  user.department && user.department.deliveryUnit
                    ? user.department.deliveryUnit.name
                    : ""
                }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <label
              class="d-inline-flex align-items-center w-100"
              title="Hit 'Enter' to search"
            >
              Search:
              <b-input-group>
                <b-form-input
                  ref="search"
                  autocomplete="off"
                  type="search"
                  placeholder="Delivery unit..."
                  @keyup.enter="doSearch"
                  class="form-control form-control-sm ms-2"
                ></b-form-input>
                <b-input-group-append v-if="search != ''" class="ms-1">
                  <b-button
                    variant="outline-danger"
                    class="align-middle"
                    @click="clearSearch"
                  >
                    <i class="bx bx-x font-size-18"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </label>
          </div>
        </div>

        <div class="accordion w-100" role="tablist">
          <b-card no-body class="mb-0" v-for="(campus, key) in filteredList" :key="key">
            <b-card-header header-tag="header" class="p-0">
              <b-list-group-item
                button
                action
                tabindex="0"
                v-b-toggle="`accordion-${key}`"
                class="list-group-item list-group-item-action text-left text-info"
              >
                <i class="far fa-list-alt font-size-15 align-middle me-2"></i>
                {{ campus.campusName }}
              </b-list-group-item>
            </b-card-header>
            <b-collapse :id="`accordion-${key}`" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-form-group
                  v-for="deliveryUnit in campus.deliveryUnits"
                  :key="deliveryUnit.id"
                >
                  <div class="d-flex">
                    <b-form-checkbox v-model="deliveryUnit.isSelected"
                      ><span class="ms-1">{{ deliveryUnit.name }}</span></b-form-checkbox
                    > <span class="mx-2">|</span>
                    <div
                      class="
                        form-check form-checkbox-outline form-check-success
                        mb-0
                      "
                    >
                      <input
                        type="checkbox"
                        v-model="deliveryUnit.withAccess"
                        class="form-check-input"
                        title="Has access to this delivery unit"
                      />
                    </div>
                  </div>
                </b-form-group>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>
      <div class="modal-footer pb-1">
        <b-button size="sm" variant="info" @click="processAccess">
          <i class="bx bx-paper-plane align-middle me-1 font-size-12"></i> Set
          Access</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
